import { useState, useContext, useLayoutEffect } from 'react';
import { AppContext } from '../contexts/AppContext';

type SelectorSize = {
  width: number;
  height: number;
};

type SelectorSizeProp = {
  selector?: string;
  footer?: number;
  viewMode?: string;
  watcherSelector?: string[];
};

/**
 * これHookを使用して、下記の変量を取得できる
 * selectorHeight4Table：selectorはTableのscrollたら、scrollのheightを取得
 * selectorTop：selectorからwindowのtopまでの距離
 * windowSize：windowのinnerWidthとinnerHeight
 * @param props
 * @returns
 */
export const useSelectorSize = (props: SelectorSizeProp) => {
  const { selector = '.tralit-table-body', footer = 40, viewMode = 'chart-table', watcherSelector = [selector] } = props;

  const { sizeMode } = useContext(AppContext);
  const [selectorSize, setSelectorSize] = useState<SelectorSize>({
    width: 0,
    height: 0,
  });
  const [selectorTop, setSelectorTop] = useState<number>(575);
  const [selectorHeight4Table, setSelectorHeight4Table] = useState(415);

  const updateSize = () => {
    if (selector) {
      const element = document.querySelector(selector);
      if (element) {
        const container = document.querySelector('.react-grid-layout');
        const rect = element.getBoundingClientRect();
        const top = rect.top + window.scrollY;
        if (container) {
          const height = container.clientHeight + 66 - top;
          setSelectorHeight4Table(height);
        } else {
          const height = document.body.clientHeight - top - footer;
          setSelectorHeight4Table(height);
        }
        setSelectorTop(top);
        setSelectorSize({
          width: element.clientWidth,
          height: element.clientHeight,
        });
      }
    }
  };

  useLayoutEffect(() => {
    updateSize();
    window.addEventListener('resize', updateSize);
    setTimeout(() => {
      updateSize();
    }, 300);
    let resizeObserver;
    if (watcherSelector && watcherSelector.length > 0) {
      resizeObserver = new ResizeObserver((entries) => {
        for (const entry of entries) {
          if (entry.contentBoxSize) {
            // Firefox implements `contentBoxSize` as a single content rect, rather than an array
            updateSize();
          }
        }
        console.log('Size changed');
      });
      watcherSelector.forEach((element) => {
        if (document.querySelector(element)) {
          resizeObserver.observe(document.querySelector(element));
        }
      });
    }
    return () => {
      window.removeEventListener('resize', updateSize);
      if (resizeObserver && watcherSelector && watcherSelector.length > 0) {
        watcherSelector.forEach((element) => {
          if (document.querySelector(element)) {
            resizeObserver.unobserve(document.querySelector(element));
          }
        });
      }
    };
  }, []);

  useLayoutEffect(() => {
    setTimeout(() => {
      updateSize();
    }, 100);
  }, [sizeMode, viewMode]);

  return { selectorSize, selectorTop, selectorHeight4Table };
};
